"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "getEvent", {
  enumerable: true,
  get: function get() {
    return _getEvent["default"];
  }
});
var _getEvent = _interopRequireDefault(require("./getEvent"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }